import React from 'react';
import './PrivacyPolicy.css';
import { Typography } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <Typography variant="h3" component="h1" gutterBottom>Privacy Policy</Typography>
        <Typography variant="body1" gutterBottom>Last updated: September 11, 2025</Typography>

        <Typography variant="h5" component="h2" gutterBottom>Introduction</Typography>
        <Typography variant="body1" gutterBottom>
          Welcome to A1Facts.ai ("we", "our", "us"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website a1facts.ai, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the "Site"). Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom>Collection of Your Information</Typography>
        <Typography variant="body1" gutterBottom>
          We may collect information about you in a variety of ways. The information we may collect on the Site includes:
        </Typography>
        <ul>
          <li><Typography variant="body1">Personal Data</Typography></li>
          <li><Typography variant="body1">Derivative Data</Typography></li>
          <li><Typography variant="body1">Financial Data</Typography></li>
          <li><Typography variant="body1">Data from Social Networks</Typography></li>
        </ul>

        <Typography variant="h5" component="h2" gutterBottom>Use of Your Information</Typography>
        <Typography variant="body1" gutterBottom>
          Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:
        </Typography>
        <ul>
          <li><Typography variant="body1">Create and manage your account.</Typography></li>
          <li><Typography variant="body1">Email you regarding your account or order.</Typography></li>
          <li><Typography variant="body1">Enable user-to-user communications.</Typography></li>
          <li><Typography variant="body1">Fulfill and manage purchases, orders, payments, and other transactions related to the Site.</Typography></li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
